import { getHelpCenterAri } from '@helpcenter/meta';
import { createResource, type RouterDataContext } from 'react-resource-router';
import type { MediaApiUploadToken } from 'rest/portal';
// eslint-disable-next-line no-restricted-imports
import { HelpHelpCenterAri } from '@atlassian/ari';
import { fetchJson } from '@atlassian/help-center-common-util/fetch/fetch';

export const mediaUploadCredentialsResource = createResource<MediaApiUploadToken>({
	type: 'CSM_MEDIA_UPLOAD_CREDENTIALS_RESOURCE',
	getKey: () => `csm-media-upload-credentials`,
	getData: async ({ match }: RouterDataContext) => {
		const { helpCenterId } = HelpHelpCenterAri.parse(getHelpCenterAri());
		return fetchJson(
			`/rest/jcs/internal/1/support-site/${helpCenterId}/issue/${
				match.params.requestKey || ''
			}/media/credentials/upload`,
			{
				method: 'GET',
				headers: {
					'Content-type': 'application/json',
				},
			},
		);
	},
	maxAge: 10 * 60 * 1000, // 10 minutes
});
